<template>
  <modal v-show="ready"
         id="modal-template"
         v-bind="modalProps"
         @close="$emit('close')"
  >
    <span slot='title'>
      <template v-if="title">
        <i :class="['fa', icon, { 'mr-2': icon }]" aria-hidden='true'></i> {{ $t(title) }}
      </template>
      <template v-else>
        <div v-html="templateTitle"></div>
      </template>
    </span>
    <span slot='body'>
      <component :is="component"
                 ref="modalComponent"
                 v-bind="componentProps"
                 :loading.sync="loading"
      ></component>
    </span>
    <div slot='footer'>
      <div class='d-flex justify-content-end'>
        <button v-for="button in buttons"
                :key="button.label"
                :disabled="button.validate ? errors.any() || loading : null"
                :id='button.label'
                class='btn ml-3'
                :class="['btn', 'ml-3', button.classes]"
                @click="click(button)">
          <i v-if="button.icon"
             :class="['fa', 'mr-2', button.icon]"
             aria-hidden='true'>
          </i> {{ $t(button.label) }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from './Modal.vue'

export default {
  name: 'ModalTemplate',
  props: {
    component: {
      required: true
    },
    componentProps: {
      required: false,
      default: () => {}
    },
    title: {
      required: false,
      default: ''
    },
    templateTitle: {
      required: false,
      default: ''
    },
    buttons: {
      required: false,
      default: () => []
    },
    modalProps: {
      required: false
    },
    icon: {
      required: false,
      default: ''
    },
    onMounted: {
      required: false,
      type: Function,
      default: () => {}
    }
  },
  components: {
    modal
  },
  data () {
    return {
      ready: false,
      loading: false
    }
  },
  methods: {
    click: function (button) {
      if (button.validate) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.handlerButton(button)
          }
        })
      } else {
        this.handlerButton(button)
      }
    },
    handlerButton: function (button) {
      if (!button.handler) {
        console.log('undefined handler at button', button.label)
        return
      }
      button.handler(this.$refs.modalComponent)
    }
  },
  mounted () {
    this.ready = true
    this.onMounted(this.$refs.modalComponent)
  }
}
</script>
